module.exports = __webpack_public_path__ + "html/wistia-player_1bf13e376ea900be5cc2b084c867d198.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wistia-player.html
// module id = ze4q
// module chunks = 17